/* eslint-disable no-nested-ternary */
import ValueColumn from "components/financials/modern/selection/ValueColumn";
import VariationColumn from "components/financials/modern/selection/VariationColumn";
import derivedValuesFromSelection from "components/financials/modern/selection/derivedValuesFromSelection";
import type { IndicatorSelection, SheetIndicator } from "components/financials/modern/types";
import { useIntl } from "react-intl";

interface SelectionHighLowAverageRangeValuesProps {
  indicator: SheetIndicator;
  selection: IndicatorSelection[];
}
export default function SelectionHighLowAverageRangeValues({
  indicator,
  selection,
}: SelectionHighLowAverageRangeValuesProps) {
  const intl = useIntl();
  const derivedSelectionValues = derivedValuesFromSelection(selection);
  if (!derivedSelectionValues) {
    return null;
  }

  const { variation, minValue, maxValue, avgValue } = derivedSelectionValues;
  if (!indicator.numberFormatOptions) {
    return (
      <div className="flex space-x-6">
        <VariationColumn variation={variation} />
      </div>
    );
  }

  const formatter = new Intl.NumberFormat("en-US", {
    style: indicator.numberFormatOptions.style as "decimal" | "currency" | "percent",
    notation: indicator.numberFormatOptions.notation as any,
    compactDisplay: indicator.numberFormatOptions.compactDisplay as any,
    minimumFractionDigits: indicator.numberFormatOptions.minimumFractionDigits,
    maximumFractionDigits: indicator.numberFormatOptions.maximumFractionDigits,
    minimumSignificantDigits: indicator.numberFormatOptions.minimumSignificantDigits,
    maximumSignificantDigits: indicator.numberFormatOptions.maximumSignificantDigits,
    minimumIntegerDigits: indicator.numberFormatOptions.minimumIntegerDigits,
  });

  return (
    <div className="flex items-center space-x-4">
      <VariationColumn variation={variation} />

      <div className="flex space-x-6 rounded-xl bg-slate-50 p-2 px-3 dark:bg-slate-800">
        <ValueColumn
          label={intl.formatMessage({ defaultMessage: "Mín.", id: "qutJrd", description: "Menor valor" })}
          value={formatter.format(minValue)}
        />
        <ValueColumn
          label={intl.formatMessage({ defaultMessage: "Máx.", id: "dLrkfk", description: "Maior valor" })}
          value={formatter.format(maxValue)}
        />
        <ValueColumn
          label={intl.formatMessage({ defaultMessage: "Méd.", id: "y7v/i2", description: "Média" })}
          value={formatter.format(avgValue)}
        />
      </div>
    </div>
  );
}
